import { FinanceCircular } from '../types/catalog';

// Circular comercial oficial FCA Compañía Financiera (Stellantis) — Promociones 0 km Fiat, octubre 2026.
// Las cuotas se calculan con el coeficiente "Cuota 1 x $1.000 con IVA" de la circular.
// El Plan UVA Rent a Car (canal Venta Especial) no se publica: es una línea para empresas.
export const fiatCircular: FinanceCircular = {
  brandId: 'fiat',
  lender: 'FCA Compañía Financiera',
  reference: 'Circular comercial Nro. 016.26 · Octubre 2026',
  validFrom: '2026-10-01',
  validUntil: '2026-10-31',
  managementFeePct: 18,
  notes: [
    'La cuota no incluye seguro automotor.',
    'Sujeto a aprobación crediticia de FCA Compañía Financiera.',
  ],
  lines: [
    {
      id: 'fiat-tasa-fija-18',
      name: 'Campaña Fiat Tasa Fija',
      detail: 'Toda la gama',
      maxAmount: 18000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 18, tna: 0, dealerContributionPct: 11, installmentPer1000: 56.22 },
        { term: 24, tna: 10.9, dealerContributionPct: 11, installmentPer1000: 48.95 },
        { term: 36, tna: 20.9, dealerContributionPct: 11, installmentPer1000: 41.58 },
      ],
    },
    {
      id: 'fiat-tasa-fija-24',
      name: 'Campaña Fiat Tasa Fija',
      detail: 'Toda la gama',
      maxAmount: 24000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 11, installmentPer1000: 84.33 },
        { term: 18, tna: 8.9, dealerContributionPct: 11, installmentPer1000: 61.76 },
        { term: 24, tna: 17.9, dealerContributionPct: 11, installmentPer1000: 53.48 },
        { term: 36, tna: 25.9, dealerContributionPct: 11, installmentPer1000: 45.05 },
      ],
    },
    {
      id: 'fiat-tasa-fija-28',
      name: 'Campaña Fiat Tasa Fija',
      detail: 'Cronos, Pulse, Fastback y Toro',
      maxAmount: 28000000,
      models: ['Cronos', 'Pulse', 'Fastback', 'Toro'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 12, installmentPer1000: 84.33 },
        { term: 18, tna: 0, dealerContributionPct: 12, installmentPer1000: 56.22 },
        { term: 24, tna: 5.9, dealerContributionPct: 12, installmentPer1000: 45.8 },
        { term: 36, tna: 18.9, dealerContributionPct: 12, installmentPer1000: 40.21 },
      ],
    },
    {
      id: 'fiat-uva-30',
      name: 'Promo UVA Fiat',
      detail: 'Toda la gama',
      maxAmount: 30000000,
      models: 'all',
      rateType: 'uva',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 6, installmentPer1000: 84.33 },
        { term: 18, tna: 0, dealerContributionPct: 10, installmentPer1000: 56.22 },
        { term: 24, tna: 0, dealerContributionPct: 10, installmentPer1000: 42.17 },
        { term: 36, tna: 0, dealerContributionPct: 10, installmentPer1000: 28.11 },
        { term: 48, tna: 5.9, dealerContributionPct: 12, installmentPer1000: 24.71 },
        { term: 60, tna: 9.9, dealerContributionPct: 12, installmentPer1000: 23.11 },
      ],
    },
    {
      id: 'fiat-titano-35',
      name: 'Titano',
      detail: 'Exclusiva Fiat Titano',
      maxAmount: 35000000,
      models: ['Titano'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 10, installmentPer1000: 84.33 },
        { term: 18, tna: 13.9, dealerContributionPct: 10, installmentPer1000: 64.95 },
        { term: 24, tna: 21.9, dealerContributionPct: 10, installmentPer1000: 56.13 },
        { term: 36, tna: 28.9, dealerContributionPct: 10, installmentPer1000: 47.18 },
        { term: 48, tna: 31.9, dealerContributionPct: 10, installmentPer1000: 42.88 },
        { term: 60, tna: 34.9, dealerContributionPct: 10, installmentPer1000: 41.64 },
      ],
    },
    {
      id: 'fiat-taxi-remis-18',
      name: 'Promo Taxis y Remises',
      detail: 'Taxis (IVA 10,5%) y remises (IVA 21%) con habilitación',
      maxAmount: 18000000,
      models: 'all',
      rateType: 'fija',
      audience: 'taxi-remis',
      channel: 'TRAD',
      terms: [
        { term: 18, tna: 0, dealerContributionPct: 11, installmentPer1000: 56.22 },
        { term: 24, tna: 10.9, dealerContributionPct: 11, installmentPer1000: 48.95 },
        { term: 36, tna: 20.9, dealerContributionPct: 11, installmentPer1000: 41.58 },
      ],
    },
  ],
};
